{
    "error": "Fehler",
    "table_column_view": {
        "save": {
            "title": "Ansicht konnte nicht gespeichert werden"
        }
    },
    "unknown": "Ein unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    "timeout": "Die Anfrage konnte nicht verarbeitet werden, bitte versuchen Sie es später erneut.",
    "unavailable": "Sie sind entweder offline oder unsere Server sind momentan leider nicht verfügbar, bitten versuchen Sie es später erneut.",
    "unauthorized_action": "Sie sind nicht authorisiert, diese Aktion durchzuführen.",
    "internal_server": "Ein interner Server Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
    "already_exists": "Es ist ein Konflikt aufgetreten, die Resource existiert bereits.",
    "parallel_editing": "Diese Ressource wurde bereits von einem anderen Benutzer:in modifiziert. Bitte aktualisieren Sie die Seite und wenden Sie Ihre Aktualisierungen erneut an.",
    "login": {
        "title": "Login leider nicht erfolgreich.",
        "message_unauthorized": "Bitte überprüfen Sie Ihren Benutzernamen und Passwort.",
        "message_forbidden": "Ihr Account wurde deaktiviert.",
        "clear_cookies": "Löschen Sie Ihre Cookies"
    },
    "auth": {
        "title": "Warnung",
        "not_authenticated": "Nicht authentifiziert.",
        "account_suspended": "Ihr Account wurde deaktiviert."
    },
    "form": {
        "title": "Fehlende Daten",
        "not_all_fields_filled": "Nicht alle erforderlichen Felder sind ausgefüllt. Bitte füllen Sie diese aus und versuchen Sie es erneut.",
        "message": "Bitte überprüfen Sie das alle erforderlichen Felder ausgefüllt sind.",
        "amount_error": "Die Beträge stimmen nicht überein."
    },
    "password": {
        "title": "Passwortänderung ist fehlgeschlagen",
        "message": "Ihr Passwort kann leider nicht geändert werden."
    },
    "bug_report": {
        "title": "Fehler",
        "message": "Senden des Feedbacks ist fehlgeschlagen."
    },
    "request": {
        "create": {
            "title": "Einreichen Ihres Antrages ist fehlgeschlagen"
        },
        "approval_process_submit": {
            "title": "Einreichen fehlgeschlagen"
        },
        "edit": {
            "title": "Bearbeitung fehlgeschlagen"
        },
        "cancel": {
            "title": "Abbrechen fehlgeschlagen"
        },
        "approved": {
            "title": "Freigabe fehlgeschlagen"
        },
        "reviewed": {
            "title": "Überprüfung fehlgeschlagen"
        },
        "paid": {
            "title": "Zahlung fehlgeschlagen"
        },
        "exported": {
            "title": "Export fehlgeschlagen"
        },
        "rejected": {
            "title": "Ablehnung fehlgeschlagen",
            "message": "Ablehnen des Antrages ist fehlgeschlagen."
        },
        "request_changes": {
            "title": "Änderungen anfordern fehlgeschlagen"
        },
        "reject_folder": {
            "title": "Leere Reise kann nicht abgelehnt werden"
        },
        "send_reminder": {
            "title": "Senden fehlgeschlagen"
        },
        "payment": {
            "title": "Zahlungsabwicklung fehlgeschlagen"
        },
        "not_found": {
            "title": "Objekt nicht gefunden.",
            "message": "Das angeforderte Objekt wurde nicht gefunden."
        },
        "tax": {
            "title": "Bearbeitung des Steuerwerts ist fehlgeschlagen."
        },
        "fetch": {
            "title": "Aktualisierung fehlgeschlagen",
            "message": "Aktualisierung der Anträge ist fehlgeschlagen."
        },
        "reset": {
            "cannot_reset_purchase_request": {
                "title": "Fehler",
                "message": "Ein Kaufantrag kann nicht zurückgesetzt werden."
            },
            "cannot_reset_processed_request": {
                "title": "Fehler",
                "message": "Ein vollständig bearbeiteter Antrag kann nicht zurückgesetzt werden."
            },
            "cannot_reset_card_request": {
                "title": "Fehler",
                "message": "Ein Antrag mit einer Karte kann nicht zurückgesetzt werden."
            }
        },
        "restore": {
            "title": "Fehler"
        },
        "sepa": {
            "title": "Export fehlgeschlagen",
            "message": "SEPA XML Generierung fehlgeschlagen."
        },
        "archived": {
            "title": "Fehler"
        },
        "opos_excluded": {
            "title": "Fehler",
            "message": "Der Posten konnte nicht aus der OPOS-Liste ausgeschlossen werden"
        },
        "opos_included": {
            "title": "Fehler",
            "message": "Die Position konnte nicht wieder in die OPOS Liste aufgenommen werden"
        },
        "opos_included_bulk": {
            "title": "Fehler",
            "message": "Die Positionen konnten nicht wieder in die OPOS Liste aufgenommen werden"
        },
        "missing_field": {
            "must_be_added": "Muss hinzugefügt werden, bevor Sie fortfahren können.",
            "must_be_adjusted": "Muss angepasst werden, bevor Sie fortfahren können."
        }
    },
    "file": {
        "upload": {
            "title": "Fehler",
            "message": "Hochladen der Datei ist fehlgeschlagen."
        },
        "duplicates": {
            "title": "Warnung",
            "message": "Duplikate sind nicht erlaubt."
        },
        "delete": {
            "title": "Fehler",
            "message": "Löschen der Datei ist fehlgeschlagen."
        },
        "export": {
            "title": "Fehler",
            "message": "Export fehlgeschlagen."
        },
        "export_no_data": {
            "title": "Warnung",
            "message": "Für die angegebene Abfrage wurden keine Daten gefunden."
        },
        "loading": {
            "title": "Fehler",
            "message": "Einige Dateien konnten nicht geladen werden."
        },
        "too_big": {
            "title": "Fehler",
            "message": "Datei überschreitet 10 MB. Bitte laden Sie eine kleinere Datei hoch."
        },
        "too_many_invoices": {
            "title": "Fehler",
            "message": "Aufgrund einer Einschränkung von DATEV können Sie nicht mehr als 50 Dateien zu einem Antrag hochladen."
        },
        "not_all_exported": {
            "title": "Warnung",
            "message": "Nicht alle Anträge wurden exportiert."
        },
        "download": {
            "title": "Fehler",
            "message": "Ihr Download ist fehlgeschlagen"
        },
        "unsupported_file_type": {
            "title": "Fehler",
            "message": "Sie versuchen ein nicht unterstütztes Dateiformat hochzuladen. Bitte versuchen Sie ein anderes Dateiformat z.B. {{allowedFormats}}"
        }
    },
    "comment": {
        "save": {
            "title": "Fehler",
            "message": "Kommentar konnte nicht gespeichert werden."
        },
        "update": {
            "title": "Fehler",
            "message": "Kommentar konnte nicht aktualisiert werden."
        },
        "delete": {
            "title": "Fehler",
            "message": "Kommentar konnte nicht gelöscht werden."
        }
    },
    "subscription": {
        "delete": {
            "title": "Fehler",
            "message": "Abonnement konnte nicht gelöscht werden."
        }
    },
    "transaction": {
        "delete": {
            "title": "Fehler",
            "message": "Transaktion konnte nicht gelöscht werden."
        },
        "bulk_delete": {
            "title": "Fehler",
            "message": "Transaktionen konnten nicht gelöscht werden."
        },
        "update_category": {
            "title": "Fehler",
            "message": "Transaktionskategorie konnte nicht geändert werden."
        }
    },
    "vendor": {
        "create": {
            "title": "Die Erstellung des Lieferanten ist fehlgeschlagen."
        },
        "edit": {
            "title": "Bearbeitung fehlgeschlagen."
        },
        "delete": {
            "title": "Fehler",
            "message": "Fehler beim Löschen des Lieferanten."
        },
        "incompatible_creditor_number": "Nicht kompatibel mit DATEV"
    },
    "cost_center": {
        "create": {
            "title": "Erstellung der Kostenstelle ist fehlgeschlagen."
        },
        "edit": {
            "title": "Bearbeitung fehlgeschlagen"
        },
        "delete": {
            "title": "Fehler",
            "message": "Kostenstelle konnte nicht gelöscht werden."
        }
    },
    "employee": {
        "create": {
            "title": "Mitarbeiter:in konnte nicht erstellt werden."
        },
        "edit": {
            "title": "Bearbeitung fehlgeschlagen"
        },
        "delete": {
            "title": "Fehler",
            "message": "Mitarbeiter:in konnte nicht gelöscht werden."
        },
        "possible_approvers": {
            "title": "Fehler",
            "message": "Fehler beim Laden der/die Freigeber:in."
        },
        "exists": "Mitarbeiter:in existiert bereits",
        "invite": {
            "title": "Mitarbeiter:in einladen"
        },
        "missing": "Mitarbeiter:in fehlt.",
        "no_creditor_number": {
            "title": "Kreditorennummer fehlt",
            "message": "Bitte fügen Sie eine Kreditorennummer zu diesem Angestellten bevor Sie diesen Antrag als \"geprüft\" markieren"
        },
        "creditor_number_unsynced": {
            "title": "Kreditoren-Stammdaten nicht aktualisiert",
            "message": "Die Kreditorendaten dieses Antrags unterscheiden sich von den Kreditoren-Stammdaten im Mitarbeiter:innenprofil. Bitte synchronisieren Sie die Daten, um eine korrekte Erstattungsabwicklung zu gewährleisten."
        }
    },
    "employee_absence": {
        "update": {
            "title": "Aktualisierung fehlgeschlagen"
        }
    },
    "settings": {
        "edit": {
            "title": "Bearbeitung fehlgeschlagen",
            "messge": "Einstellung konnte nicht aktualisiert werden."
        }
    },
    "reset_password": {
        "title": "Token ungültig.",
        "message": "Bitte klicken Sie auf den Link, den Sie in Ihrer Email erhalten haben, um Ihr Passwort zurückzusetzen."
    },
    "verify_email": {
        "title": "Token ungültig.",
        "message": "Bitte klicken Sie auf den Link, den Sie in Ihrer Email erhalten haben, um Ihr Passwort zurückzusetzen."
    },
    "offline": {
        "title": "Netzwerkfehler",
        "message": "Es scheint als wären Sie offline. Bitte aktualisieren Sie die Seite, um es erneut zu versuchen."
    },
    "payment_subscription": {
        "general": {
            "title": "Fehler",
            "message": "Ein Fehler ist aufgetreten."
        },
        "failed": {
            "title": "Fehler",
            "message": "Ihre Zahlung ist fehlgeschlagen. Bitte versuchen Sie es erneut."
        },
        "cancel": {
            "title": "Fehler",
            "message": "Das Zahlungsabonnement konnte nicht gekündigt werden."
        },
        "reactivate": {
            "title": "Fehler",
            "message": "Das Zahlungsabonnement konnte nicht reaktiviert werden."
        },
        "delete": {
            "title": "Fehler",
            "message": "Fehler beim Löschen des Zahlungsabonnements."
        },
        "missing_card": {
            "title": "Fehler",
            "message": "Bitte geben Sie Ihre Karteninformationen ein."
        },
        "invalid_card": {
            "title": "Fehler",
            "message": "Ihre Karteninformationen sind ungültig."
        },
        "inv_download": {
            "title": "Fehler",
            "message": "Fehler beim Herunterladen der neuesten Rechnung.."
        },
        "update": {
            "title": "Fehler",
            "message": "Fehler beim Bearbeiten des Zahlungsabonnements."
        },
        "create": {
            "title": "Fehler",
            "message": "Fehler beim Erstellen des Zahlungsabonnements."
        },
        "failed_payment": "Authentifizierung für diese Karte ist fehlgeschlagen."
    },
    "csv_matching": {
        "title": "Fehler",
        "process": "CSV konnte nicht verarbeitet werden.",
        "no_emails": "Die CSV-Datei enthält keine E-Mail-Adressen. Bitte stellen Sie sicher, dass Sie nur E-Mail-Adressen hochladen.",
        "no_new_emails": "Die CSV-Datei enthält keine neuen E-Mail-Adressen. Bitte stellen Sie sicher, dass Sie E-Mail-Adressen hochladen, die noch nicht im Eingabefeld stehen."
    },
    "matching": {
        "title": "Fehler",
        "perform": {
            "title": "Fehler",
            "message": "Matching konnte nicht durchgeführt werden."
        },
        "determine": {
            "title": "Fehler",
            "message": "Matching Optionen konnten nicht bestimmt werden.",
            "no_transactions_found": {
                "title": "Fehler",
                "message": "Es wurden keine neuen Transaktionen erstellt."
            }
        },
        "already_in_possible_matches": "Dieser Antrag ist bereits gelistet.",
        "expense_has_already_transaction_set": "Dieser Antrag wurde bereits mit einer anderen Transaktion ge-matched.",
        "cannot_manually_match_or_unmatch_card_transaction": "Eine Kartentransaktion kann nicht manuell ge-matched oder un-matched werden.",
        "cannot_match_card_expense_manually": "Ein Antrag mit einer Karte kann nicht manuell ge-matched werden.",
        "no_date_or_amount_column_found": "Matching kann nicht durchgeführt werden, ohne dass eine Datums- und Betragsspalte entdeckt wurde."
    },
    "banking": {
        "error": "Banking Fehler",
        "bank_rejected_payment": "Ihre Bank hat die Zahlung abgewiesen.",
        "account_does_not_support_payment": "Ihre Bank bietet keinen Support für Online SEPA Zahlungen an.",
        "expense_already_in_payment_process": "Dieser Antrag befindet sich bereits in einem Zahlungsprozess. Falls Sie diese Bezahlung gestartet haben, füllen Sie bitte das Webform aus, das sich dabei geöffnet hat. Falls nichts geöffnet wurde, checken Sie bitte Ihre Browser Popup Einstellungen. Das Webform erlischt in 10 Minuten und ab dann kann der Prozess erneut gestartet werden.",
        "missing_vendor_data": "Der ausgewählte Lieferant hat keine IBAN oder BIC gespeichert.",
        "missing_requester_data": "Der/die ausgewählte Antragsteller:in hat keine IBAN oder BIC gespeichert für eine Rückerstattung.",
        "webform_failed": "Validierung des Webformulars ist fehlgeschlagen.",
        "delete": {
            "title": "Banking Fehler",
            "message": "Fehler beim Löschen der Bankverbindung."
        },
        "has_to_be_default": "Dieser Account muss als Standardverbindung gesetzt sein, da keine andere Verbindung existiert.",
        "no_supported_interface": "Diese Bank unterstützt keine der benötigten Online-Schnittstellen.",
        "account": {
            "delete": {
                "title": "Fehler",
                "message": "Fehler beim Löschen des Bankaccounts."
            },
            "cannot_delete_default": {
                "title": "Warnung",
                "message": "Default Account kann nicht gelöscht werden."
            }
        },
        "import": {
            "title": "Fehler",
            "message": "Anbindung der Bankverbindung fehlgeschlagen. Bitte versuchen Sie es erneut.",
            "message_with_reason": "Bankanfrage fehlgeschlagen: \"{{message}}\". Bitte kontaktieren Sie den Support und leiten Sie diese Fehlermeldung weiter, damit wir Ihnen helfen können, das Problem zu identifizieren.",
            "conflict": {
                "title": "Fehler",
                "message": "Anbindung der Bankverbindung fehlgeschlagen, da diese Verbindung bereits existiert."
            }
        },
        "new_interface_added": {
            "title": "Fehler",
            "message": "Anbindung des neuen Interfaces fehlgeschlagen. Bitte versuchen Sie es erneut."
        },
        "payment": {
            "title": "Fehler",
            "message": "Zahlung fehlgeschlagen. Bitte versuchen Sie es erneut."
        },
        "webform_abort": {
            "title": "Warnung",
            "message": "Bank Webform ist abgebrochen worden oder ausgelaufen. Bitte starten Sie den Prozess erneut."
        },
        "download": {
            "title": "Fehler",
            "message": "Herunterladen der Transaktionen fehlgeschlagen oder Zeitlimit überschritten. Bitte versuchen Sie die Bankverbindung zu löschen und erneut anzubinden."
        },
        "sepa_generation_missing_company_iban_or_bic": "Firmen IBAN und BIC in den Einstellungen sind notwendig, um ein SEPA XML zu erstellen.",
        "refresh_payment_status": {
            "title": "Fehler",
            "message": "Zahlungsstatus konnte nicht aktualisiert werden."
        }
    },
    "expense_account": {
        "update": {
            "title": "Fehler"
        },
        "incompatible": {
            "title": "Error",
            "message": "Sachkonto ist inkompatibel."
        }
    },
    "cost_center_2": {
        "update": {
            "title": "Fehler"
        }
    },
    "stripe": {
        "connection_error": "Es konnte keine Verbindung zum Bezahlungsserver erstellt werden. Bitte prüfen Sie Ihre Internetverbindung.",
        "insufficient_funds": "Ihre Karte hat nicht genügend Geldmittel, um die Bezahlung abzuschließen.",
        "authentication_failure": "Authentifizierung für diese Karte ist fehlgeschlagen, bitte versuchen Sie eine andere Karte.",
        "incomplete_number": "Ihre Kartennummer ist unvollständig.",
        "invalid_number": "Ihre Kartennummer ist ungültig.",
        "incomplete_expiry": "Das Ablaufdatum Ihrer Karte ist unvollständig.",
        "invalid_expiry_year_past": "Das Jahr des Ablaufdatums Ihrer Karte liegt in der Vergangenheit.",
        "invalid_expiry_month_past": "Der Monat des Ablaufdatums Ihrer Karte liegt in der Vergangenheit.",
        "incomplete_cvc": "Der Sicherheitscode Ihrer Karte ist unvollständig.",
        "incomplete_zip": "Ihre Postleitzahl ist unvollständig."
    },
    "loader": {
        "title": "Loader Fehler",
        "message": "Initiale Daten konnten nicht geladen werden. Bitte kontaktieren Sie das Support Team."
    },
    "expense_filter": {
        "updated": "Fehler"
    },
    "fetch": {
        "title": "Aktualisierungsfehler",
        "message": "Aktualisierung ist fehlgeschlagen."
    },
    "ocr": {
        "title": "OCR Fehler",
        "message": "Automatisches Auslesen der PDF Datei ist fehlgeschlagen.",
        "failed_to_update_expense": "Das Aktualisieren des Antrags mit den ausgelesenen OCR Daten ist fehlgeschlagen.",
        "select_ocr_source": "Bitte wählen Sie eine OCR Quelle aus.",
        "still_processing": "Die Rechnung wird noch ausgelesen. Versuchen Sie es erneut, sobald die Rechnung ausgelesen wurde."
    },
    "einvoice": {
        "title": "Fehler mit E-Rechnung"
    },
    "notifications": {
        "title": "Objekt nicht gefunden",
        "message": "Objekt ist möglicherweise gelöscht worden."
    },
    "invoice_inbox": {
        "delete": {
            "title": "Fehler"
        },
        "move": { "title": "Rechnung verschieben fehlgeschlagen" },
        "assign": { "title": "Die Mitarbeiterzuweisung ist fehlgeschlagen" },
        "unassign": { "title": "Die Aufhebung der Mitarbeiterzuweisung ist fehlgeschlagen" },
        "change_document_type": { "title": "Änderung des Dokumenttyps fehlgeschlagen" }
    },
    "cards": {
        "kyb": {
            "start": {
                "title": "Fehler"
            },
            "update": {
                "title": "Fehler"
            },
            "duplicate_email": "Doppelte Email für Direktor und Aktionär"
        },
        "create": {
            "title": "Fehler",
            "phone_number_not_verified": "Ausgewählte:r Mitarbeiter:in muss seine/ihre Mobiltelefonnummer verifiziert haben, um eine Karte auf seinen Namen ausgestellt zu bekommen.",
            "user_not_enrolled": "Der Benutzer:in ist noch nicht im Kartenprogramm angemeldet.",
            "failed": "Erstellen der Karte fehlgeschlagen. Bitte versuchen Sie es erneut oder kontaktieren Sie unseren Support."
        },
        "update_status": {
            "title": "Aktualisierung fehlgeschlagen"
        },
        "edit": {
            "title": "Aktualisierung fehlgeschlagen"
        },
        "something_went_wrong": "Bei dieser Karte ist etwas fehlgeschlagen, bitte kontaktieren Sie unseren Support",
        "not_enough_funds": "Der Geschäftsaccount hat zu wenig Geld verfügbar.",
        "topup": {
            "title": "Aufladen der Karte fehlgeschlagen"
        },
        "expense_card_creation": "Erstellung einer Karte für diesen Antrag ist fehlgeschlagen. Bitte versuchen Sie es erneut oder kontaktieren Sie unseren Support.",
        "top_up": {
            "must_be_active": "Karte muss aktiv sein, um sie aufladen zu können."
        },
        "wrong_pin": "Dieser PIN ist falsch.",
        "wrong_verification_code": "Der Verifizierungscode ist falsch.",
        "already_used_email": "Diese Email-Adresse wurde bereits einmal verwendet.",
        "frequency_exceeded": "Diese Operation wurde zu oft durchgeführt und kann momentan nicht wiederholt werden.",
        "physical_card_upgrade": {
            "title": "Warning",
            "message": "Ihre physische Karte wurde erstellt aber ein Problem ist dabei aufgetreten. Sie können mehr Informationen dazu auf der Detailseite dieser Karte finden."
        },
        "auto_approver_for_card_request": "Auto Approver kann nicht für Smart Card Anträge ausgewählt werden.",
        "auto_approver_limit_exceeded": "Dieser Betrag übersteigt das Limit des Auto Approvers.",
        "card_or_matched_request_cannot_be_deleted": "Ein Antrag mit einer Smart Card oder welcher mit einer Transaktion ge-matched ist, kann nicht abgelehnt werden.",
        "phyiscal_disabled": "Physische Karten sind momentan nicht verfügbar, werden aber bald freigeschalten. Bitte kontaktieren Sie unser Support Team, um mehr zu erfahren.",
        "not_allowed_in_demo": "Diese Aktion ist in einer Demo nicht möglich.",
        "cannot_change_requester_with_card_attachted": "Der/die Antragsteller:in kann nicht geändert werden, wenn bereits eine Karte für diesen Antrag existiert.",
        "account_statement_download": "Herunterladen des Kontoauszugs ist fehlgeschlagen.",
        "new_smart_card_subs_cannot_start_in_past": "Ein neues Abonnement mit einer Karte kann nicht in der Vergangenheit starten.",
        "limit_change_request": "Anfrage zur Änderung des Kartenlimits fehlgeschlagen.",
        "card_program_onboarding_not_finished": {
            "title": "Fehler",
            "message": "Sie müssen das Karten-onboarding vollständig beenden, bevor Sie diese Aktion durführen können."
        },
        "step_up_token": {
            "title": "Fehler",
            "message": "Ihre Aktion ist nicht erlaubt. Bitte prüfen Sie, ob Ihre Telefonnummer im Kartenprogramm registriert ist."
        },
        "weavr_error": {
            "title": "Error",
            "message": "Something went wrong when loading the details of the credit card. Please try again later."
        }
    },
    "corporate": {
        "setup_user_passcode": {
            "title": "Fehler",
            "message": "Erstellung des Pincodes ist fehlgeschlagen. Bitte versuchen Sie es erneut oder kontaktieren Sie unseren Support."
        },
        "verify_email": {
            "title": "Fehler",
            "message": "Verifizierung der Emailadresse fehlgeschlagen."
        },
        "email_verification_code": {
            "title": "Fehler",
            "message": "Verifizierungscode konnte nicht versandt werden."
        },
        "verify_mobile": {
            "title": "Fehler",
            "message": "Verifizierung der Mobilnummer fehlgeschlagen."
        },
        "mobile_verification_code": {
            "title": "Fehler",
            "message": "Verifizierungscode konnte nicht versandt werden."
        },
        "enroll_user": {
            "title": "Fehler",
            "message": "Hinzufügen des Users ins Kartenprogramm ist fehlgeschlagen."
        },
        "account_create": {
            "title": "Fehler",
            "message": "Geschäftskonto konnte nicht erstellt werden."
        },
        "company_details_submit": {
            "title": "Fehler",
            "message": "Senden der Firmendaten fehlgeschlagen."
        },
        "no_password": "Diese:r Benutzer:in hat noch keine finway PIN erstellt. Bitte absolvieren Sie das Karten-Onboarding, um eine finway PIN zu erstellen.",
        "sub_card_only_eur": "Eine Karte kann nur für Abonnements ausgestellt werden, welche EUR als Währung verwenden.",
        "weavr_step_up_required": "Sie müssen das Onboarding für das Kartenprogramm vollständig abschließen, bevor Sie diese Aktion durchführen können.",
        "authentication_expired": "Ihr Authentifizierungsversuch ist abgelaufen. Bitte versuchen Sie es erneut.",
        "cannot_be_performed_due_to_cards_enrollment_in_other_company": "Diese Aktion kann nicht durchgeführt werden, da eine Abhängigkeit zu einem anderem Kartenprogramm besteht."
    },
    "wallet": {
        "wire_send": {
            "title": "Fehler",
            "message": "Transfer konnte nicht gestartet werden."
        }
    },
    "passcode": {
        "recovery": {
            "wrong_passcode": {
                "title": "Fehler",
                "message": "Alte finway PIN ist falsch."
            }
        }
    },
    "payment_failed": {
        "message": "Die Zahlung ist fehlgeschlagen.",
        "description": "Begründung Ihrer Bank: {{message}}. Bitte versuchen Sie erneut die Zahlung durchzuführen.",
        "none": "keine.",
        "tag": "Transaktion fehlgeschlagen"
    },
    "workflow": {
        "no_appropriate_workflow_rule_found": "Keine passende Workflow Regel gefunden."
    },
    "splits": {
        "unable_sync_tax": {
            "title": "Fehler",
            "message": "Die Steuer kann nicht angepasst werden, da der Prozentsatz der aufgeteilten Summe nicht 100% beträgt."
        }
    },
    "table_fetch_failed": {
        "title": "Eine Tabelle konnte nicht geladen werden",
        "message": "Sie können die Tabelle erneut laden wenn Sie auf den Neu laden Button klicken."
    },
    "liquidity": {
        "deleted_scenario": {
            "title": "Fehler",
            "message": "Scenario konnte nicht gelöscht werden."
        },
        "deleted_forecast_rule": {
            "title": "Fehler",
            "message": "Fehler beim Löschen einer Prognoseregel."
        }
    },
    "download_spreadsheet_template": "Download der Tabellenvorlage fehlgeschlagen",
    "data_validation": "Daten-Validierung fehlgeschlagen",
    "data_upload": "Daten-Upload fehlgeschlagen",
    "import_result_history": "Importverlauf konnte nicht abgerufen werden",
    "download_data_upload_result_log": "Log download fehlgeschlagen",
    "transaction_category": {
        "order": {
            "title": "Fehler",
            "message": "Fehler beim Aktualisieren der Reihenfolge der Transaktionskategorie."
        },
        "create": {
            "title": "Fehler",
            "message": "Kategorie konnte nicht erstellt werden."
        },
        "update": {
            "title": "Fehler",
            "message": "Kategorie konnte nicht bearbeitet werden."
        },
        "delete": {
            "title": "Fehler",
            "message": "Fehler beim Löschen der Transaktionskategorie."
        }
    },
    "update": {
        "title": "Fehler",
        "message": "Aktualisierung fehlgeschlagen."
    },
    "payment_method": {
        "update": {
            "title": "Fehler",
            "message": "Payment Method update failed."
        },
        "update_in_stripe": {
            "title": "Fehler",
            "message": "Zahlungsmethode wurde nicht akzeptiert. Bitte überprüfen Sie die Daten oder wählen eine andere Zahlungsmethode."
        }
    },
    "expense_tag": {
        "create": {
            "title": "Erstellen fehlgeschlagen"
        },
        "delete": {
            "title": "Löschen fehlgeschlagen"
        },
        "attach": {
            "title": "Tag anhängen fehlgeschlagen"
        },
        "detach": {
            "title": "Tag trennen fehlgeschlagen"
        }
    },
    "datev_online": {
        "missing_account_month": {
            "title": "Fehler",
            "message": "DUO Export ist bei mind. einem Antrag fehlgeschlagen, da der Buchungsmonat nicht in Ihrem verbundenem DUO Account konfiguriert ist."
        },
        "unsupported_file_type": {
            "title": "Fehler",
            "message": "Sie versuchen, einen Antrag mit einer Rechnung zu exportieren, die ein nicht unterstütztes Dateiformat enthält. Bitte versuchen Sie ein anderes Rechnungsdateiformat z.B. .pdf, .png, .jpeg"
        },
        "account_not_found": {
            "title": "Fehler",
            "message": "Auf Ihren DUO Account konnte nicht zugegriffen werden. Dies kann zum Beispiel passieren, wenn Sie ihn woanders verlinkt haben. Wir haben den Account automatisch getrennt - bitte verbinden Sie ihn erneut in den Einstellungen."
        },
        "export_timeout": {
            "title": "Fehler",
            "message": "Der DUO Export konnte nicht verarbeitet werden, bitte versuchen Sie es später erneut."
        },
        "damaged_invoice": {
            "title": "Fehler",
            "message": "Sie versuchen, einen Antrag mit einer Rechnung zu exportieren, die ein falsches Dateiformat hat. Bitte versuchen Sie es mit einer anderen Rechnungsdatei."
        },
        "export_success": {
            "title": "Erfolg",
            "message": "DUO Export erfolgreich ausgeführt."
        },
        "export_error": {
            "title": "Fehler",
            "message": "DUO Export ist fehlgeschlagen."
        },
        "export_partial": {
            "title": "Warnung",
            "message": "DUO Export ist bei manchen Anträgen fehlgeschlagen."
        },
        "invalid_access_token": {
            "title": "Warnung",
            "message": "DUO Export ist bei mindestens einem Antrag fehlgeschlagen, da der DATEV-Zugangs-Token fehlt. Bitte in den Einstellungen verbinden."
        }
    },
    "bulk_data_upload": {
        "download_report": "Bericht konnte nicht heruntergeladen werden",
        "download_import": "Herunterladen der Importdatei fehlgeschlagen"
    },
    "vat": {
        "vat_rate_fetch": {
            "message": "Die MwSt.-Sätze konnten nicht geladen werden."
        }
    },
    "trip_folder": {
        "cancel": {
            "title": "Abbrechen fehlgeschlagen"
        }
    },
    "outdated_version": {
        "title": "Warnung",
        "message": "Ihre Version ist veraltet, bitte aktualisieren sie die Seite im Browser."
    },
    "mfa": {
        "enforce": "Globales MFA update fehlgeschlagen",
        "deforce": "Globales MFA update fehlgeschlagen"
    },
    "sso": {
        "no_access": {
            "title": "Zugriff geblockt",
            "description": "Sie sind nicht teil dieser Organisation. Kontaktieren Sie Ihren Vorgesetzten um Zugriff für diese Email-Adresse zu erhalten."
        },
        "toggle": "Verbindung konnte nicht de-/aktiviert werden"
    },
    "ocr_error": "OCR Fehler",
    "profile": {
        "edit": {
            "title": "Bearbeitung fehlgeschlagen",
            "message": "Profil konnte nicht aktualisiert werden."
        }
    },
    "datev_wallet_csv": {
        "title": "Achtung - Export unvollständig",
        "message": "Die Spalte \"Konto\" und/oder \"Gegenkonto\" weist zum Teil leere Zellen auf, überprüfen Sie die Export Einstellungen oder ergänzen Sie fehlende Kreditoren. Ergänzen Sie ggf. auch die Mandanten- & Beraternummer."
    },
    "change_history": {
        "export": {
            "title": "Fehler",
            "message": "Das Änderungsprotokoll konnte nicht exporteirt werden."
        }
    },
    "invoice": {
        "fetch_failed": {
            "message": "Die Rechnung konnte nicht geladen werden."
        }
    },
    "invoice_number": {
        "invalid_character": {
            "title": "Ungültige Zeichen in Rechnungsnummer",
            "message": "Bitte überprüfen Sie Ihre Eingabe. Unsichtbare Zeichen und die folgenden Zeichen sind nicht erlaubt: \"§°´"
        }
    },
    "featureFlag": {
        "p2p_order_not_enabled": {
            "title": "Purchase-2-Pay Modul deaktiviert",
            "message": "Das Purchase-2-Pay Modul wurde deaktiviert, daher können keine Bestellungen und Lieferscheine erstellt werden. Ändern Sie die Art des Dokuments zu „Rechnung“, um es verarbeiten zu können."
        }
    },
    "purchase_order": {
        "approve": {
            "title": "Freigabe fehlgeschlagen"
        },
        "delete": {
            "title": "Fehler",
            "message": "Bestellung konnte nicht gelöscht werden."
        },
        "auto_match": {
            "title": "Automatische Zuordnung fehlgeschlagen",
            "message": "Automatische Zuordnung der Positionen fehlgeschlagen. Bitte versuchen Sie es erneut oder ordnen Sie manuell zu."
        }
    },
    "delivery_note": {
        "delete": {
            "title": "Fehler",
            "message": "Lieferschein konnte nicht gelöscht werden."
        }
    },
    "export": {
        "too_many_invoices_to_export_to_datev": {
            "title": "Fehler",
            "message": "Der DUO-Export kann nicht durchgeführt werden, da DUO maximal 50 Dateien pro Antrag zulässt."
        }
    }
}
